import type { ReactNode } from 'react'
import { AppLoadingState } from '@shared/ui'
import './learning-loading-state.css'

export interface LearningLoadingStateProps {
  readonly description: ReactNode
  readonly title: ReactNode
}

export function LearningLoadingState({ description, title }: LearningLoadingStateProps) {
  return (
    <AppLoadingState
      className="learningLoadingState"
      message={description}
      minHeight="clamp(320px, calc(100vh - 360px), 560px)"
      title={title}
    />
  )
}
